import { render, staticRenderFns } from "./PaymentPendingAlertModalSection.vue?vue&type=template&id=0abfbe05"
import script from "./PaymentPendingAlertModalSection.vue?vue&type=script&lang=ts"
export * from "./PaymentPendingAlertModalSection.vue?vue&type=script&lang=ts"
import style0 from "./PaymentPendingAlertModalSection.vue?vue&type=style&index=0&id=0abfbe05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports